import { render, staticRenderFns } from "./bussiness.vue?vue&type=template&id=44bcd5a4&scoped=true&"
import script from "./bussiness.vue?vue&type=script&lang=js&"
export * from "./bussiness.vue?vue&type=script&lang=js&"
import style0 from "./bussiness.vue?vue&type=style&index=0&id=44bcd5a4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bcd5a4",
  null
  
)

export default component.exports